import React from "react";

export interface StatCardProps {
  label: string;
  value: string | number;
  sub?: string;
  /** Percentage change vs. previous period. */
  delta?: number;
  /** Direction that counts as "good". Defaults to up = good. */
  goodDirection?: "up" | "down";
  deltaContext?: string;
  loading?: boolean;
}

export const StatCard: React.FC<StatCardProps> = ({
  label,
  value,
  sub,
  delta,
  goodDirection = "up",
  deltaContext = "vs prev period",
  loading = false,
}) => {
  if (loading) {
    return (
      <div className="an-stat-card">
        <span className="an-stat-label an-skeleton">{label}</span>
        <span className="an-stat-value an-skeleton">0000</span>
      </div>
    );
  }

  const hasDelta = delta !== undefined && delta !== null && !Number.isNaN(delta);
  let deltaClass = "an-stat-delta--neutral";
  let arrow = "→";
  if (hasDelta && delta !== 0) {
    const isGood = goodDirection === "up" ? delta > 0 : delta < 0;
    deltaClass = isGood ? "an-stat-delta--positive" : "an-stat-delta--negative";
    arrow = delta > 0 ? "↑" : "↓";
  }

  return (
    <div className="an-stat-card">
      <span className="an-stat-label" title={label}>
        {label}
      </span>
      <span className="an-stat-value">{value}</span>
      {sub && <span className="an-stat-sub">{sub}</span>}
      {hasDelta && (
        <span className={`an-stat-delta ${deltaClass}`}>
          <span>
            {arrow} {Math.abs(delta as number).toFixed(1)}%
          </span>
          <span className="an-stat-delta-context">{deltaContext}</span>
        </span>
      )}
    </div>
  );
};

export default StatCard;
